export function needCategoryMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      needCategoryId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateNeedCategoryId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateNeedCategoryId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}
export function fixGetManyNeedCategories(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function needCategoryMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, needCategoryId: json.result.objectId},
  };
}